/* eslint-disable import/order */
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { jiraSearchRoute } from '@jira/router-routes__jira-search-routes/src/jiraSearchRoute.tsx';
import { JiraSearchRedirect } from './ui/redirect/index.tsx';
import { jiraSearchResource } from './ui/redirect/resources/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const jiraSearchRouteEntry: Route = createEntry(jiraSearchRoute, () => ({
	group: 'redirects',
	// eslint-disable-next-line no-restricted-syntax
	component: JiraSearchRedirect,
	isRedirect: true,
	layout: globalLayout,
	resources: [...getNavigationResources(), jiraSearchResource],
	forPaint: [LazyAtlassianNavigation],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
